export default {"src":"/_next/static/media/stevia.e57c355b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};